import * as React from "react";
import Helmet from "../Helment";

const Support = () => {
  return (
    <Helmet title="پشتیبانی">
      <div>
        <iframe
          src={"https://www.goftino.com/c/IdMUN8"}
          className="support"
          height={"100%"}
          width={"100%"}
        />
      </div>
    </Helmet>
  );
};

export default Support;
